__turbopack_context__.v({
  "answerIn": "play-page-module__vEcQ6a__answerIn",
  "categoryCard": "play-page-module__vEcQ6a__categoryCard",
  "categoryControls": "play-page-module__vEcQ6a__categoryControls",
  "categoryCopy": "play-page-module__vEcQ6a__categoryCopy",
  "categoryFallback": "play-page-module__vEcQ6a__categoryFallback",
  "categoryGrid": "play-page-module__vEcQ6a__categoryGrid",
  "categoryHeader": "play-page-module__vEcQ6a__categoryHeader",
  "categoryIcon": "play-page-module__vEcQ6a__categoryIcon",
  "categoryImage": "play-page-module__vEcQ6a__categoryImage",
  "categorySection": "play-page-module__vEcQ6a__categorySection",
  "categoryShade": "play-page-module__vEcQ6a__categoryShade",
  "consoleHalo": "play-page-module__vEcQ6a__consoleHalo",
  "consoleVisual": "play-page-module__vEcQ6a__consoleVisual",
  "directoryFloat": "play-page-module__vEcQ6a__directoryFloat",
  "emptyState": "play-page-module__vEcQ6a__emptyState",
  "eyebrow": "play-page-module__vEcQ6a__eyebrow",
  "faq": "play-page-module__vEcQ6a__faq",
  "faqIntro": "play-page-module__vEcQ6a__faqIntro",
  "faqList": "play-page-module__vEcQ6a__faqList",
  "faqToggle": "play-page-module__vEcQ6a__faqToggle",
  "finalCta": "play-page-module__vEcQ6a__finalCta",
  "helpObject": "play-page-module__vEcQ6a__helpObject",
  "howTo": "play-page-module__vEcQ6a__howTo",
  "howToCopy": "play-page-module__vEcQ6a__howToCopy",
  "intro": "play-page-module__vEcQ6a__intro",
  "introActionIcon": "play-page-module__vEcQ6a__introActionIcon",
  "introActions": "play-page-module__vEcQ6a__introActions",
  "introArtwork": "play-page-module__vEcQ6a__introArtwork",
  "introCopy": "play-page-module__vEcQ6a__introCopy",
  "introEyebrow": "play-page-module__vEcQ6a__introEyebrow",
  "introIn": "play-page-module__vEcQ6a__introIn",
  "introPrimary": "play-page-module__vEcQ6a__introPrimary",
  "introSecondary": "play-page-module__vEcQ6a__introSecondary",
  "introVisual": "play-page-module__vEcQ6a__introVisual",
  "introVisualHalo": "play-page-module__vEcQ6a__introVisualHalo",
  "modeArrow": "play-page-module__vEcQ6a__modeArrow",
  "modeCard": "play-page-module__vEcQ6a__modeCard",
  "modeGrid": "play-page-module__vEcQ6a__modeGrid",
  "modeIn": "play-page-module__vEcQ6a__modeIn",
  "modeSection": "play-page-module__vEcQ6a__modeSection",
  "monsterFeature": "play-page-module__vEcQ6a__monsterFeature",
  "monsterFeatureCopy": "play-page-module__vEcQ6a__monsterFeatureCopy",
  "monsterFeatureCta": "play-page-module__vEcQ6a__monsterFeatureCta",
  "monsterFeatureEyebrow": "play-page-module__vEcQ6a__monsterFeatureEyebrow",
  "monsterFeatureImage": "play-page-module__vEcQ6a__monsterFeatureImage",
  "monsterFeatureMeta": "play-page-module__vEcQ6a__monsterFeatureMeta",
  "monsterFeatureShade": "play-page-module__vEcQ6a__monsterFeatureShade",
  "moreCard": "play-page-module__vEcQ6a__moreCard",
  "page": "play-page-module__vEcQ6a__page",
  "popular": "play-page-module__vEcQ6a__popular",
  "popularHeader": "play-page-module__vEcQ6a__popularHeader",
  "popularImage": "play-page-module__vEcQ6a__popularImage",
  "popularList": "play-page-module__vEcQ6a__popularList",
  "primaryButton": "play-page-module__vEcQ6a__primaryButton",
  "searchField": "play-page-module__vEcQ6a__searchField",
  "secondaryButton": "play-page-module__vEcQ6a__secondaryButton",
  "showLess": "play-page-module__vEcQ6a__showLess",
  "sortField": "play-page-module__vEcQ6a__sortField",
  "stat": "play-page-module__vEcQ6a__stat",
  "stats": "play-page-module__vEcQ6a__stats",
  "statsIn": "play-page-module__vEcQ6a__statsIn",
  "stepNumber": "play-page-module__vEcQ6a__stepNumber",
  "steps": "play-page-module__vEcQ6a__steps",
});
